<template>
  <div class="policy">
    <navigation></navigation>
    <div style="width: 100%; height: 80px"></div>
    <div style="width: 1200px; margin: 0 auto">
      <!-- 搜索框 -->
      <div class="inpBox" style="height: 40px">
        <div
          style="float: left; height: 50px; line-height: 50px"
          @click="areaSelect()"
        >
          <div
            style="
              float: left;
              font-family: MicrosoftYaHei;
              font-weight: 400;
              color: rgba(102, 102, 102, 1);
              cursor: pointe;
              position: relative;
              cursor: pointer;
              margin-left: 30px;
              line-height: 50px;
            "
          >
            地区：
            <div
              style="
                width: 1920px;
                height: 700px;
                background: rgba(0, 0, 0, 0);
                position: absolute;
                z-index: 21;
                left: -190px;
                top: -300px;
              "
              v-show="areaFlag == 2"
            ></div>
            <div
              style="
                width: 246px;
                height: 346px;
                background: rgba(255, 255, 255, 1);
                box-shadow: 0px 10px 30px 0px rgba(153, 153, 153, 0.5);
                border-radius: 5px;
                position: absolute;
                z-index: 22;
                left: 22px;
                top: 43px;
                opacity: 1;
                padding-top: 30px;
                padding-left: 30px;
              "
              v-show="areaFlag == 2"
            >
              <div
                style="
                  float: left;
                  color: #333333;
                  width: 52px;
                  height: 14px;
                  line-height: 14px;
                  font-size: 14px;
                  margin-bottom: 20px;
                  cursor: pointer;
                "
                v-for="(item, index) in areaList"
                :key="index"
                @click="areaFn(item,index)"
                :style="
                  areaIndex == index
                    ? 'font-weight:500;color:#3476C1;'
                    : ''
                "
              >
                {{ item.name }}
              </div>
            </div>
          </div>
          <div
            style="
              float: left;
              margin-right: 0px;
              font-size: 14px;
              font-family: MicrosoftYaHei;
              font-weight: 500;
              color: rgba(0, 0, 0, 1);
              cursor: pointer;
            "
          >
            {{ areaList[this.areaIndex].name }}
          </div>
          <img
            src="../../static/policy/i1.png"
            alt=""
            style="
              display: block;
              float: left;
              width: 9px;
              height: 5px;
              margin: 23px 30px 0 10px;
            "
            v-show="areaFlag == 1"
          />
          <img
            src="../../static/policy/i2.png"
            alt=""
            style="
              display: block;
              float: left;
              width: 9px;
              height: 5px;
              margin: 23px 30px 0 10px;
            "
            v-show="areaFlag == 2"
          />
        </div>

        <div class="inp">
          <input
            type="text"
            placeholder="请输入关键词"
            ref="content"
            name="cname"
            v-model="name"
          />
          <button type="submit" @click="getPolicyList(1)">搜索</button>
        </div>
      </div>
      <!-- 内容 -->
      <div class="zhengce">
        <div
          class="article"
          v-for="(item, index) in policyList"
          :key="index"
          @click="toPolityDetail(item.id)"
        >
          <span class="span1">{{ item.name }}</span>
          <span>{{ item.createDate.substring(0, 10) }}</span>
        </div>
      </div>
    </div>

    <!-- 分页 -->
    <div class="page">
      <el-pagination
        @current-change="currentChange"
        :page-size="pageSize"
        background
        layout="prev, pager, next"
        :total="total"
        prev-text="上一页"
        next-text="下一页"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import navigation from "@/components/common/navigation";

export default {
  name: "policy",
  components: {
    navigation,
  },
  data() {
    return {
      policyList: [],
      areaList: [{}],
      areaIndex: 0,
      areaFlag: 1,
      provinceCode: 0, //默认全国编码
      pageSize: 13, //每页条数
      total: 0,
    };
  },
  methods: {
        // 时间格式化
    formmaterTime(time) {
      const dt = new Date(time)
      const y = dt.getFullYear()
      const m = this.padZero(dt.getMonth() + 1)
      const d = this.padZero(dt.getDate())
      return `${y}-${m}-${d}`
    },
    padZero(n) {
      return n > 9 ? n : '0' + n
    },
    toPolityDetail(id) {
      // this.$router.push('/policyDetail')
      this.$router.push({
        path: "/policyDetail",
        query: {
          id,
        },
      });
    },
    currentChange(pageNum) {
      this.getPolicyList(pageNum);
    },
    getPolicyList(pageNum = 1) {
      //政策列表
      this.$axios
        .post("/v1/cloud/common/policy", {
          pageSize: this.pageSize,
          provinceCode: this.provinceCode,
          pageNum,
          pageSize: this.pageSize,
          name: this.name,
        })
        .then(({ data }) => {
          if (data) {
            data.list.forEach(item => {
              item.createDate = this.formmaterTime(item.createDate)
            })
            this.policyList = data.list;
            this.pages = data.pages;
            this.total = data.total;
          }
        })
        .catch((error) => {
          this.$message({
            message: error.response.data.message,
            type: "warning",
          });
        });
    },
    areaSelect() {
      if (this.areaFlag == 1) {
        this.areaFlag = 2;
      } else if (this.areaFlag == 2) {
        this.areaFlag = 1;
      }
    },
    areaFn(code,index) {
      this.areaIndex = index
      this.provinceCode = code.code;
      //政策列表
      this.getPolicyList();
    },
  },
  created() {
    var _this = this;
    document.onkeydown = function (e) {
      let key = window.event.keyCode;
      if (key == 13) {
        _this.search();
      }
    };
    this.getPolicyList();
    //地区名列表
    this.$axios
      .get("/v1/cloud/common/policy/area")
      .then(({ data }) => {
        if (data) {
          this.areaList = data;
        }
      })
      .catch((error) => {
        this.$message({
          message: error.response.data.message,
          type: "warning",
        });
      });
  },
  mounted() {
    console.log('asdasdasd');
    //滚动条从顶部开始
    let osTop = document.documentElement.scrollTop || document.body.scrollTop;
    if (osTop > 0) {
      document.documentElement.scrollTop = document.body.scrollTop = 0;
    }
  },
};
</script>

<style scoped lang="less">
/deep/ .number{
  height: 30px;
  font-weight: normal;
  line-height: 30px;
}
/deep/ .btn-prev{
  height: 30px;
  font-weight: normal;
}
/deep/ .more{
  height: 30px;
  font-weight: normal;
}
/deep/ .btn-next{
  height: 30px;
  font-weight: normal;
}
.policy {
  // -webkit-touch-callout: none; /* iOS Safari */
  // -webkit-user-select: none; /* Chrome/Safari/Opera */
  // -khtml-user-select: none; /* Konqueror */
  // -moz-user-select: none; /* Firefox */
  // -ms-user-select: none; /* Internet Explorer/Edge */
  // user-select: none;

  width: 100%;
  .page {
    height: 40px;
    text-align: center;
    width: 1200px;
    margin: 0 auto;
    margin-bottom: 50px;
    /deep/.btn-prev,
    /deep/.btn-next {
      padding: 0 10px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #666666;
      background-color: #F5F5F5;
    }
    /deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
      background-color: #3476c1;
    }
  }

  .inpBox {
    margin: 20px 0;
    .inp {
      width: 700px;
      height: 40px;
      float: right;
      margin-right: 115px;
      background: rgba(255, 255, 255, 1);
      input {
        width: 600px;
        height: 100%;
        float: left;
        border: 1px solid #dddddd;
        outline: none;
        margin: 0 auto;
        vertical-align: middle;
        border-radius: 3px;
        text-indent: 11px;
      }
      input::placeholder {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #999999;
      }
      button {
        height: 40px;
        width: 100px;
        color: #fffffefe;
        border: none;
        outline: none;
        background-color: #3476c1;
        margin-right: -1px;
        text-align: center;
        line-height: 40px;
        cursor: pointer;
        border-radius: 0px 3px 3px 0px;
      }
    }
  }
  .zhengce {
    height: 600px;
    // height:auto;
    overflow: hidden;
    margin-top: 30px;
    padding: 0 20px;
    .article {
      width: 100%;
      overflow: hidden;
      span {
        float: left;
        font-size: 16px;
        color: #333333ff;
        cursor: pointer;
        margin-bottom: 20px;
        text-indent: 10px;
      }
      .span1 {
        background-image: url("../../static/policy/fangkuai.png");
        background-size: 5px 5px;
        background-position: 1px center;
        background-repeat: no-repeat;
      }
      span:nth-child(2n) {
        float: right;
      }
    }
    .article:hover {
      span {
        color: #3476c1;
      }
    }
  }
}
</style>
